import React from 'react'
import { TASK_PRIORITY } from '../../../util/constants'
import ListToolbar from '../../dataGrid/ListToolBar'
import FilterPopover from '../../dataGrid/FilterPopover'
import TableData from '../../atoms/table/TableData'
import { Scheduler } from '../../scheduler/Scheduler'

export default function TasksUI({
	search,
	setSearch,
	columns,
	chips,
	innerTab,
	handleInnerTab,
	filteredRows,
	handleExport,
	filterAnchor,
	openFilter,
	closeFilter,
	clearFilters,
	statusFilter,
	setStatusFilter,
	priorityFilter,
	setPriorityFilter,
	onActionBegin,
	eventSettings,
	partyMembers,
	showTitle = '',
	isStaff = false,
	...props
}) {
	return (
		<>
			<ListToolbar
				searchPlaceholder="Search task"
				searchValue={search}
				onSearchChange={setSearch}
				chips={chips}
				showTabes={true}
				innerTab={innerTab}
				onInnerTabChange={handleInnerTab}
				onClearFilters={clearFilters}
				onOpenFilter={openFilter}
				onExport={handleExport}
			/>

			<FilterPopover
				anchorEl={filterAnchor}
				open={Boolean(filterAnchor)}
				onClose={closeFilter}
				onClear={clearFilters}
				onApply={closeFilter}
				sections={[
					{
						id: 'status',
						title: 'Status',
						options: ['New', 'In Progress', 'Completed', 'Overdue'],
						selected: statusFilter,
						onToggle: (val, checked) =>
							setStatusFilter((prev) =>
								checked
									? [...prev, val]
									: prev.filter((x) => x !== val)
							),
					},
					{
						id: 'priority',
						title: 'Priority',
						options: TASK_PRIORITY,
						selected: priorityFilter,
						onToggle: (val, checked) =>
							setPriorityFilter((prev) =>
								checked
									? [...prev, val]
									: prev.filter((x) => x !== val)
							),
					},
				]}
			/>

			{innerTab ? (
				<div className="calendarWrp vendorTask">
					<div className="calendarInner">
						<Scheduler
							disableWeddingDateButton={true}
							onActionBegin={onActionBegin}
							eventSettings={eventSettings}
							partyMembers={partyMembers}
							showTitle={showTitle}
							allowDragAndDrop={false}
							allowResizing={false}
							title="Task Timeline"
							height={'77dvh'}
							isStaff={isStaff}
						/>
					</div>
				</div>
			) : (
				<TableData
					rows={filteredRows}
					getRowId={(row) => row._id}
					columns={columns}
					checkboxSelection={false}
					sx={{
						height: 'calc(100dvh - 230px)',
						'@media (max-width: 768px)': {
							height: 'calc(100dvh - 260px)',
						},
					}}
				/>
			)}
		</>
	)
}
